import { motion } from "framer-motion";
import { FaCar, FaGamepad, FaCode, FaBook } from "react-icons/fa";
import Card from "../components/Card";

const interests = [
  { name: "Driving", icon: <FaCar className="text-yellow-400 text-3xl" /> },
  { name: "Gaming", icon: <FaGamepad className="text-pink-500 text-3xl" /> },
  { name: "Coding", icon: <FaCode className="text-red-500 text-3xl" /> },
  { name: "Reading", icon: <FaBook className="text-blue-500 text-3xl" /> },
];

const details = [
  ["Birthday", "4 July 2002"],
  ["Age", "24"],
  ["Degree", "Masters in IT"],
  ["Phone", "090-3666-8177"],
  ["Email", "ebinbenny055@gmail.com"],
  ["City", "Thrissur, Kerala, India"],
  ["Freelance", "Available"],
];

export default function About() {
  return (
    <section className="relative py-24 px-5 md:px-10 overflow-hidden">
      <div className="relative z-10 container mx-auto max-w-5xl">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-14"
        >
          <p className="text-violet-400 text-sm font-medium tracking-widest uppercase mb-2">
            Get to know me
          </p>
          <h2 className="text-3xl md:text-4xl font-bold grad-text">
            About Me
          </h2>
        </motion.div>

        {/* Profile Section */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="mb-16 glass rounded-3xl p-6 sm:p-8 shadow-xl"
        >
          <div className="space-y-6">
            <h3 className="text-2xl font-bold grad-text">Software Developer</h3>

            <p className="text-gray-300 italic leading-relaxed">
              Welcome to my portfolio! I'm <strong className="text-white">Ebin Benny</strong>,
              a Software Developer from Kerala, India, specializing in{" "}
              <strong className="text-white">React, Laravel, Java, and Spring Boot</strong>.
              I build scalable web applications and modern user interfaces.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-3 gap-x-6">
              {details.map(([label, value]) => (
                <p key={label} className="text-gray-300 text-sm">
                  <span className="text-violet-400">▹ {label}: </span>
                  {value}
                </p>
              ))}
            </div>

            <p className="text-gray-400 leading-relaxed text-sm">
              In my journey as a developer, I've had the opportunity to work on
              various projects, from creating dynamic websites to developing
              custom software solutions. I'm dedicated to staying updated with
              the latest trends and technologies in the field.
            </p>
          </div>
        </motion.div>

        {/* Stat Cards */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mb-16">
          <Card title="Happy Clients" value="15+" />
          <Card title="Projects" value="10+" />
          <Card title="Hours of Support" value="500+" />
          <Card title="Experience" value="1 Year" />
        </div>

        {/* Interests */}
        <h3 className="text-2xl font-semibold mb-6 text-center md:text-left">
          Interests
        </h3>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6">
          {interests.map((interest, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.05 }}
              className="flex flex-col items-center justify-center glass p-6 rounded-2xl hover:scale-105 hover:border-violet-400/40 transition-all"
            >
              {interest.icon}
              <p className="mt-3 font-semibold text-sm sm:text-base">
                {interest.name}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
